var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      ref: "driverDetail",
      attrs: {
        visible: _vm.drawer,
        "destroy-on-close": true,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        size: "60%",
        withHeader: "false",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
        open: _vm.openDetail,
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "align-items": "center" },
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("div", [_vm._v("车辆详情-" + _vm._s(_vm.info.plateNumber))]),
          _c("div", { staticClass: "tips_box" }, [
            _vm._v(
              "\n      注意：该模块信息用于上传至交通部门监管信息平台，请保持信息完整与正确性！\n    "
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            padding: "0 0 10px 20px",
            color: "#606266",
            "font-size": "14px",
          },
        },
        [
          _c("span", [_vm._v("信息完整度：")]),
          _c("span", [
            _vm._v(
              _vm._s(_vm.info.completeRate ? _vm.info.completeRate + "%" : "")
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "top_box" }, [
        _c("div", { staticClass: "dian" }),
        _c("div", { staticStyle: { "margin-right": "20px" } }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.info.auditState === 1
                  ? "待审核"
                  : _vm.info.auditState === 2
                  ? "审核通过"
                  : "拒绝"
              ) +
              "\n    "
          ),
        ]),
        _vm.info.auditState === 1
          ? _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "has-permi",
                        rawName: "v-has-permi",
                        value: ["vehicle_audit"],
                        expression: "['vehicle_audit']",
                      },
                    ],
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.auditClick(2)
                      },
                    },
                  },
                  [_vm._v("\n        通过\n      ")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "has-permi",
                        rawName: "v-has-permi",
                        value: ["vehicle_audit"],
                        expression: "['vehicle_audit']",
                      },
                    ],
                    attrs: { size: "small", type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.auditClick(3)
                      },
                    },
                  },
                  [_vm._v("\n        不通过\n      ")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "基础信息", name: "first" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 40 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-descriptions",
                        {
                          staticStyle: { "margin-left": "40px" },
                          attrs: { column: 1 },
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            {
                              attrs: {
                                label: "业务类型",
                                prop: "merchantName",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.bizTypeStr) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            {
                              attrs: {
                                label: "所属供应商",
                                prop: "merchantName",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.merchantName) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆注册城市" } },
                            [_vm._v(_vm._s(_vm.info.areaName))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆车架号" } },
                            [_vm._v(_vm._s(_vm.info.vin))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车牌燃料类型" } },
                            [_vm._v(_vm._s(_vm.info.fuelType))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车牌颜色" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.plateNumberColor) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "发动机排量" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.vehicleEmissions) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆检修状态" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.carMaintenanceStatus) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "卫星定位设备安装日期" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.gpsInstallDate) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "卫星定位装置品牌" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.gpsBrand) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "发票打印设备序列号" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.printDeviceNo) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "行驶证发证日期" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.drivingLicenseStart) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆图片" } },
                            _vm._l(_vm.info.images, function (item, index) {
                              return _c(
                                "el-image",
                                {
                                  key: index,
                                  staticStyle: {
                                    width: "100px",
                                    height: "100px",
                                  },
                                  attrs: {
                                    "preview-src-list": _vm.previewList,
                                    src: item,
                                  },
                                },
                                [
                                  _c("template", { slot: "error" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-bg-f6 full flex-center color-999",
                                      },
                                      [_vm._v("暂未上传图片")]
                                    ),
                                  ]),
                                ],
                                2
                              )
                            }),
                            1
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "行驶证" } },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    style:
                                      _vm.drivingLicenseEnd === "expiringSoon"
                                        ? "color: #FF881B"
                                        : _vm.drivingLicenseEnd === "expire"
                                        ? "color: #FA5151"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.drivingLicenseEnd ===
                                            "expiringSoon"
                                            ? "证照即将过期，请及时办理更新"
                                            : _vm.drivingLicenseEnd === "expire"
                                            ? "证照已过期，请及时办理更新"
                                            : ""
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "flex" },
                                  _vm._l(
                                    _vm.drivingLicenselist,
                                    function (item) {
                                      return _c(
                                        "div",
                                        { key: item, staticClass: "img_box" },
                                        [
                                          _c(
                                            "el-image",
                                            {
                                              staticStyle: {
                                                width: "120px",
                                                height: "100px",
                                                "margin-right": "20px",
                                              },
                                              attrs: {
                                                src: item.url,
                                                "preview-src-list":
                                                  _vm.previewList,
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "error" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "color-bg-f6 full flex-center color-999",
                                                    },
                                                    [_vm._v("暂未上传图片")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _c("span", [
                                            _vm._v(_vm._s(item.text)),
                                          ]),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆登记证" } },
                            _vm._l(_vm.vehicleImgList, function (item) {
                              return _c(
                                "div",
                                { key: item, staticClass: "img_box" },
                                [
                                  _c(
                                    "el-image",
                                    {
                                      staticStyle: {
                                        width: "120px",
                                        height: "100px",
                                        "margin-right": "20px",
                                      },
                                      attrs: {
                                        src: item.url,
                                        "preview-src-list": _vm.previewList,
                                      },
                                    },
                                    [
                                      _c("template", { slot: "error" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-bg-f6 full flex-center color-999",
                                          },
                                          [_vm._v("暂未上传图片")]
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _c("span", [_vm._v(_vm._s(item.text))]),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "GPS设备安装回执单" } },
                            [
                              _c(
                                "div",
                                { staticClass: "img_box" },
                                [
                                  _c(
                                    "el-image",
                                    {
                                      staticStyle: {
                                        width: "120px",
                                        height: "100px",
                                        "margin-right": "20px",
                                      },
                                      attrs: {
                                        src: _vm.info.gpsReceiptImg,
                                        "preview-src-list": _vm.previewList,
                                      },
                                    },
                                    [
                                      _c("template", { slot: "error" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-bg-f6 full flex-center color-999",
                                          },
                                          [_vm._v("暂未上传图片")]
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _c("span", [_vm._v("GPS设备安装回执单")]),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm.info.technicalRating
                            ? _c(
                                "el-descriptions-item",
                                { attrs: { label: "车辆技术等级评定" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-col flex-center",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex" },
                                        _vm._l(
                                          _vm.info.technicalRating.split(","),
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              { key: index },
                                              [
                                                _vm.isImage(item)
                                                  ? _c(
                                                      "el-image",
                                                      {
                                                        class:
                                                          _vm.info.technicalRating.split(
                                                            ","
                                                          ).length > 1
                                                            ? "margin-right-20"
                                                            : "",
                                                        staticStyle: {
                                                          width: "120px",
                                                          height: "100px",
                                                        },
                                                        attrs: {
                                                          src: item,
                                                          "preview-src-list": [
                                                            item,
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "error" },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "color-bg-f6 full flex-center color-999",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "暂未上传图片"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "font-12 color-999 box",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleDownload(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-document font-18",
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "line-1 font-16",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getFileName(
                                                                  item
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-12 margin-top-10",
                                        },
                                        [_vm._v("车辆技术等级评定")]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "技术等级评定日期" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.technicalRatingOn) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆等级评定有效期止" } },
                            [
                              _c(
                                "span",
                                {
                                  style:
                                    _vm.technicalRatingOff === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.technicalRatingOff === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.info.technicalRatingOff) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  style:
                                    _vm.technicalRatingOff === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.technicalRatingOff === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.technicalRatingOff ===
                                          "expiringSoon"
                                          ? "即将过期"
                                          : _vm.technicalRatingOff === "expire"
                                          ? "已过期"
                                          : ""
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm.info.maintenance
                            ? _c(
                                "el-descriptions-item",
                                { attrs: { label: "车辆二级维护记录卡" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-col flex-center",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex" },
                                        _vm._l(
                                          _vm.info.maintenance.split(","),
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              { key: index },
                                              [
                                                _vm.isImage(item)
                                                  ? _c(
                                                      "el-image",
                                                      {
                                                        class:
                                                          _vm.info.maintenance.split(
                                                            ","
                                                          ).length > 1
                                                            ? "margin-right-20"
                                                            : "",
                                                        staticStyle: {
                                                          width: "120px",
                                                          height: "100px",
                                                        },
                                                        attrs: {
                                                          src: item,
                                                          "preview-src-list": [
                                                            item,
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "error" },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "color-bg-f6 full flex-center color-999",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "暂未上传图片"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "font-12 color-999 box",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleDownload(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-document font-18",
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "line-1 font-16",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getFileName(
                                                                  item
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-12 margin-top-10",
                                        },
                                        [_vm._v("车辆二级维护记录卡")]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆二级维护日期" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.maintenanceOn) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆二级维护有效期止" } },
                            [
                              _c(
                                "span",
                                {
                                  style:
                                    _vm.maintenanceOff === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.maintenanceOff === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.info.maintenanceOff) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  style:
                                    _vm.maintenanceOff === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.maintenanceOff === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.maintenanceOff === "expiringSoon"
                                          ? "即将过期"
                                          : _vm.maintenanceOff === "expire"
                                          ? "已过期"
                                          : ""
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-descriptions",
                        { attrs: { column: 1 } },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "核定载客位" } },
                            [_vm._v(_vm._s(_vm.info.seats))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车型信息" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.brandName) +
                                  "-" +
                                  _vm._s(_vm.info.seriesName) +
                                  "-" +
                                  _vm._s(_vm.info.colorName) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "发动机号" } },
                            [_vm._v(_vm._s(_vm.info.engineNo))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆注册日期" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.registerDate) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆所有人" } },
                            [_vm._v(_vm._s(_vm.info.ownerName))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆类型" } },
                            [_vm._v(_vm._s(_vm.info.vehicleType))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆年度审验状态" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.annualCheckStatus) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "车辆下次年检时间" } },
                            [
                              _c(
                                "span",
                                {
                                  style:
                                    _vm.nextAnnualCheck === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.nextAnnualCheck === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.info.nextAnnualCheck) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  style:
                                    _vm.nextAnnualCheck === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.nextAnnualCheck === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.nextAnnualCheck === "expiringSoon"
                                          ? "即将过期"
                                          : _vm.nextAnnualCheck === "expire"
                                          ? "已过期"
                                          : ""
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "卫星定位装置型号" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.gpsType) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "卫星定位装置IMEI号" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.gpsImei) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "行驶证有效期止" } },
                            [
                              _c(
                                "span",
                                {
                                  style:
                                    _vm.drivingLicenseEnd === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.drivingLicenseEnd === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.info.drivingLicenseEnd) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  style:
                                    _vm.drivingLicenseEnd === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.drivingLicenseEnd === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.drivingLicenseEnd === "expiringSoon"
                                          ? "即将过期"
                                          : _vm.drivingLicenseEnd === "expire"
                                          ? "已过期"
                                          : ""
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "运营登记", name: "second" } },
            [
              _c(
                "el-descriptions",
                {
                  staticStyle: { "margin-left": "40px" },
                  attrs: { column: 1 },
                },
                [
                  _c("el-descriptions-item", { attrs: { label: "运营类型" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.info.operationType === 1
                            ? "道路运输"
                            : _vm.info.operationType === 2
                            ? "网络预约"
                            : ""
                        ) +
                        "\n        "
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "车辆运输证字号" } },
                    [_vm._v(_vm._s(_vm.info.transportNo))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "报备日期" } }, [
                    _vm._v(_vm._s(_vm.info.reportDate)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "车辆运输证发证机构" } },
                    [_vm._v(_vm._s(_vm.info.tcb))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "车辆经营区域" } },
                    [_vm._v(_vm._s(_vm.info.operateArea))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "车辆初次登记日期" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.info.firstRegisterdate) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "车辆运输证有效期起" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.info.validityBegindate) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "车辆运输证有效期止" } },
                    [
                      _c(
                        "span",
                        {
                          style:
                            _vm.validityEnddate === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.validityEnddate === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.info.validityEnddate) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: { "margin-left": "10px" },
                          style:
                            _vm.validityEnddate === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.validityEnddate === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.validityEnddate === "expiringSoon"
                                  ? "即将过期"
                                  : _vm.validityEnddate === "expire"
                                  ? "已过期"
                                  : ""
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "车辆运输证下次审验时间" } },
                    [
                      _c(
                        "span",
                        {
                          style:
                            _vm.transportCertificateCheck === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.transportCertificateCheck === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.info.transportCertificateCheck) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: { "margin-left": "10px" },
                          style:
                            _vm.transportCertificateCheck === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.transportCertificateCheck === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.transportCertificateCheck === "expiringSoon"
                                  ? "即将过期"
                                  : _vm.transportCertificateCheck === "expire"
                                  ? "已过期"
                                  : ""
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "车辆运输证" } },
                    [
                      _c("div", [
                        _c(
                          "span",
                          {
                            style:
                              _vm.validityEnddate === "expiringSoon"
                                ? "color: #FF881B"
                                : _vm.validityEnddate === "expire"
                                ? "color: #FA5151"
                                : "",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.validityEnddate === "expiringSoon"
                                    ? "证照即将过期，请及时办理更新"
                                    : _vm.validityEnddate === "expire"
                                    ? "证照已过期，请及时办理更新"
                                    : ""
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "flex" },
                          _vm._l(_vm.transportgList, function (item) {
                            return _c(
                              "div",
                              { key: item, staticClass: "img_box" },
                              [
                                _c(
                                  "el-image",
                                  {
                                    staticStyle: {
                                      width: "120px",
                                      height: "100px",
                                      "margin-right": "20px",
                                    },
                                    attrs: {
                                      src: item.url,
                                      "preview-src-list": _vm.previewList,
                                    },
                                  },
                                  [
                                    _c("template", { slot: "error" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "color-bg-f6 full flex-center color-999",
                                        },
                                        [_vm._v("暂未上传图片")]
                                      ),
                                    ]),
                                  ],
                                  2
                                ),
                                _c("span", [_vm._v(_vm._s(item.text))]),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "车辆购置发票" } },
                    [
                      _c(
                        "el-image",
                        {
                          staticStyle: {
                            width: "120px",
                            height: "100px",
                            "margin-right": "20px",
                          },
                          attrs: {
                            src: _vm.info.carInvoice,
                            "preview-src-list": _vm.previewList,
                          },
                        },
                        [
                          _c("template", { slot: "error" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-bg-f6 full flex-center color-999",
                              },
                              [_vm._v("暂未上传图片")]
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm.info.franchiseAgreement
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "加盟合作协议" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col flex-center" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                _vm._l(
                                  _vm.info.franchiseAgreement.split(","),
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      { key: index },
                                      [
                                        _vm.isImage(item)
                                          ? _c(
                                              "el-image",
                                              {
                                                class:
                                                  _vm.info.franchiseAgreement.split(
                                                    ","
                                                  ).length > 1
                                                    ? "margin-right-20"
                                                    : "",
                                                staticStyle: {
                                                  width: "120px",
                                                  height: "100px",
                                                },
                                                attrs: {
                                                  src: item,
                                                  "preview-src-list": [item],
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "error" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "color-bg-f6 full flex-center color-999",
                                                      },
                                                      [_vm._v("暂未上传图片")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "font-12 color-999 box",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleDownload(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-document font-18",
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "line-1 font-16",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getFileName(item)
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                              _c(
                                "span",
                                { staticClass: "font-12 margin-top-10" },
                                [_vm._v("加盟合作协议")]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "合作协议有效期起" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.info.franchiseAgreementOn) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "合作协议有效期止" } },
                    [
                      _c(
                        "span",
                        {
                          style:
                            _vm.franchiseAgreementOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.franchiseAgreementOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.info.franchiseAgreementOff) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: { "margin-left": "10px" },
                          style:
                            _vm.franchiseAgreementOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.franchiseAgreementOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.franchiseAgreementOff === "expiringSoon"
                                  ? "即将过期"
                                  : _vm.franchiseAgreementOff === "expire"
                                  ? "已过期"
                                  : ""
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "金融信息", name: "third" } },
            [
              _c(
                "el-descriptions",
                {
                  staticStyle: { "margin-left": "40px" },
                  attrs: { column: 1 },
                },
                [
                  _c("el-descriptions-item", { attrs: { label: "贷款机构" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.info.carBankingReqVo.organName) +
                        "\n        "
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "贷款主体" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.info.carBankingReqVo.loanSubject) +
                        "\n        "
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "担保方" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.info.carBankingReqVo.bonded) +
                        "\n        "
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "每期还款金额" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.info.carBankingReqVo.refundPlan) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "合计还款金额" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.info.carBankingReqVo.refundTotal) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "还款利息" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.info.carBankingReqVo.refundInterest) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "保险信息", name: "fourth" } },
            [
              _c(
                "div",
                { staticClass: "add_btn" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["vehicle_edit"],
                          expression: "['vehicle_edit']",
                        },
                      ],
                      staticStyle: { "margin-right": "40px" },
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.addClick()
                        },
                      },
                    },
                    [_vm._v("\n          添加保险\n        ")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.info.carInsuranceRepVo,
                    border: "",
                    size: "mini",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "insuranceTypeStr",
                      label: "保险类别",
                      align: "center",
                      width: "80",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "policyNo",
                      label: "保险号",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "insuranceCompany",
                      label: "保险公司",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "premium", label: "保费", align: "center" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sumAssured",
                      label: "保额",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "insurancePeriodBegin",
                      label: "保险生效时间",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "insurancePeriodEnd",
                      label: "保险到期时间",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "expirationDay",
                      label: "保险剩余天数",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "span",
                              {
                                style:
                                  row.expirationDay < 0 && "color: #FA5151",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.expirationDay) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.img
                              ? _c(
                                  "div",
                                  { staticClass: "flex-center flex-wrap" },
                                  [
                                    _vm._l(
                                      scope.row.img.split(","),
                                      function (item, index) {
                                        return [
                                          !_vm.isPdf(item)
                                            ? _c(
                                                "a",
                                                {
                                                  key: item,
                                                  staticClass: "file_btn",
                                                  attrs: { target: "_blank" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleLookImg(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  查看保单" +
                                                      _vm._s(index + 1) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "a",
                                                {
                                                  key: item,
                                                  staticClass: "file_btn",
                                                  attrs: {
                                                    href: item,
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  查看保单" +
                                                      _vm._s(index + 1) +
                                                      "\n                "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.info.auditState !== 2
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: ["insurance_edit"],
                                        expression: "['insurance_edit']",
                                      },
                                    ],
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editClick(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n              编辑\n            ")]
                                )
                              : _vm._e(),
                            _vm.info.auditState !== 2
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: ["vehicle_insurance_delete"],
                                        expression:
                                          "['vehicle_insurance_delete']",
                                      },
                                    ],
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteClick(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n              删除\n            ")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-tab-pane", { attrs: { label: "操作日志", name: "fifth" } }, [
            _c(
              "div",
              { staticClass: "padding-x-10" },
              [
                _c("operation-log", {
                  attrs: { list: _vm.logList, maxHeight: _vm.logTableHeight },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm.visible
        ? _c("carInsurance-add", {
            attrs: {
              visible: _vm.visible,
              carInsuranceForm: _vm.carInsuranceForm,
            },
            on: {
              saveCarInsurance: _vm.saveCarInsurance,
              closeClick: _vm.closeInsurance,
            },
          })
        : _vm._e(),
      _vm.dialogImageUrl
        ? _c("el-image", {
            ref: "reviewImage",
            staticStyle: { width: "60px", height: "60px" },
            attrs: {
              src: _vm.dialogImageUrl,
              fit: "contain",
              "preview-src-list": [_vm.dialogImageUrl],
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }